export default class DataGridModel {
    constructor(props) {
        this.title = "",
        this.sortingEnabled = true;
        this.pagination = false;
        this.selectable = false;
        this.enableFilters = false;
        this.filters = [];
        this.enableExport = false;
        this.enableSearch = false;
        this.enableDateRange = false;
        this.exportFormats = [];
        this.exportName = "grid"
        this.rowsPerPage = 10;
        this.rowClick = null;
        this.columns = null;
        this.searchFields = [];
        this.searchPlaceholder = "Search";
        this.noDataMessage = "No data";
    }
}
